import { render, staticRenderFns } from "./GroupSubscriptionsCreation.vue?vue&type=template&id=5c5488f4"
import script from "./GroupSubscriptionsCreation.vue?vue&type=script&lang=js"
export * from "./GroupSubscriptionsCreation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports